<template>
  <svg
    class="step"
    width="58px"
    height="29px"
    viewBox="1753 1123 58 29"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="One"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      transform="translate(1753.000000, 1123.000000)"
    >
      <path
        d="M0,0 L47,0 L56.5285516,12.8928447 C57.1845443,13.7804521 57.1849069,15.2190573 56.5285516,16.1071553 L47,29 L0,29 L0,0 Z"
        id="Rectangle-55"
        fill="#4990E2"
      />
      <polygon
        id="1"
        fill="#FFFFFF"
        points="18.796 21 18.796 8.256 16.366 8.256 12.982 11.82 14.674 13.296 15.898 12.45 15.898 21"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'StepOneIcon'
}
</script>
